export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.harbor-navigation li.dropdown .nav-link').click(function (e) {
      if ($(window).width() < 1200) {
        var grandparent = $(this).next();
        if ($(this).hasClass('open1') && grandparent.hasClass('opened')) {
          document.location.href = this.href;
        } else {
          $(this).addClass('open1');
          $('#navbar-primary .navbar-nav').find('i').removeClass('opened');
          $(this).next('.dropdown-toggle1').click();
        }
      } else {
        location.href = this.href;
      }
      e.preventDefault();
    });

    $('li.dropdown > .dropdown-toggle1').on('click', function (e) {
      var current = $(this).next();
      var current1 = $(this);
      var grandparent = $(this).parent().parent();
      grandparent.find('.dropdown-menu:visible').not(current).removeClass('show1');
      grandparent.find('.dropdown-toggle1').not(current1).removeClass('opened');
      $(this).toggleClass('opened');
      current.toggleClass('show1');
      e.stopPropagation();
    });
    $('.main').on('click', '.calevir_loadmore', function (e) {
      e.preventDefault();
      var calevir_loadmore_params = { 'ajaxurl': '/wp-admin/admin-ajax.php', 'posts': '', 'current_page': '1', 'max_page': null };
      var button = $(this),
        data = {
          'action': 'loadmore',
          'page': calevir_loadmore_params.current_page,
        };
      $.ajax({
        url: calevir_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#blog-result').append(data.actiondata);
            }
            button.text('Load More Blogs');
            calevir_loadmore_params.current_page++;
            if (calevir_loadmore_params.current_page == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });


    //events
    $('.main').on('click', '.events_loadmore', function (e) {
      e.preventDefault();
      var events_loadmore_params = { 'ajaxurl': '/wp-admin/admin-ajax.php', 'events': '', 'current_page': '1', 'max_page': null };
      var button = $(this),
        data = {
          'action': 'eventsmore',
          'page': events_loadmore_params.current_page,
        };
      $.ajax({
        url: events_loadmore_params.ajaxurl,
        data: data,
        type: 'POST',
        cache: false,
        dataType: 'JSON',
        beforeSend: function () {
          button.text('Loading...');
        },
        success: function (data) {
          if (data) {
            if (data.actiondata) {
              $('#event_posts').append(data.actiondata);
            }
            button.text('Load More Blogs');
            events_loadmore_params.current_page++;
            if (events_loadmore_params.current_page == button.data('num')) {
              button.remove();
            }
          } else {
            button.remove();
          }
        },
      });
    });


    // hide our element on page load

    $('.home-header').css('opacity', 0);

        $(document).ready(function(){
            $('.home-header').addClass('fadeInLeft');
        }, {
            offset: '-20%',
      });

      $('.get-section-left').css('opacity', 0);

      $('.get-section-left').waypoint(function() {
          $('.get-section-left').addClass('fadeInLeft');
      }, {
          offset: '75%',
      });

      $('.get-section-right').css('opacity', 0);

      $('.get-section-right').waypoint(function() {
          $('.get-section-right').addClass('fadeInRight');
      }, {
          offset: '75%',
      });


      $('.reviews-image-left').css('opacity', 0);

      $('.reviews-image-left').waypoint(function() {
          $('.reviews-image-left').addClass('fadeInLeft');
      }, {
          offset: '70%',
      });

      $('.reviews-heading-left').css('opacity', 0);

      $('.reviews-heading-left').waypoint(function() {
          $('.reviews-heading-left').addClass('fadeInLeft');
      }, {
          offset: '70%',
      });

      $('.reviews-content-right').css('opacity', 0);

      $('.reviews-content-right').waypoint(function() {
          $('.reviews-content-right').addClass('fadeInRight');
      }, {
          offset: '70%',
      });

      $('.be-a-part-bottom').css('opacity', 0);

      $('.be-a-part-bottom').waypoint(function() {
          $('.be-a-part-bottom').addClass('fadeInUp');
      }, {
          offset: '75%',
      });

      $('.form-from-bottom').css('opacity', 0);

      $('.form-from-bottom').waypoint(function() {
          $('.form-from-bottom').addClass('fadeInUp');
      }, {
          offset: '75%',
      });

      $('.secondary_heading').css('opacity', 0);

        $(document).ready(function(){
            $('.secondary_heading').addClass('fadeInLeft');
        }, {
            offset: '-20%',
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js